import hasClass from "./has-class";

const tbNavigation = () => {
  /* -------------------------------------------------------------- */
  /* Toggle Dropdown */
  /* -------------------------------------------------------------- */
  const dropdownMenu = () => {
    const dropdowns = document.querySelectorAll("header .dropdown > a");
    const links = document.querySelectorAll(".menu-categories-container > ul > li > a");

    dropdowns.forEach((item) => {
      const activateDropdown = (event) => {
        if(window.innerWidth > 998) {
          item.parentElement.classList.add("active");
        }
      };

      const removeActivateDropdown = (event) => {
        if(window.innerWidth > 998) {
          event.target.classList.remove("active");
        }
      };

      item.addEventListener("mouseenter", activateDropdown);
      item.addEventListener("focus", activateDropdown);
      item.parentElement.addEventListener("mouseleave", removeActivateDropdown);
    });

    const handleFocus = (event) => {
      const targetParent = event.target.parentElement;
      // Get all dropdowns that are not equal to the target parent
      const otherDropdowns = Array.from(document.querySelectorAll(".menu-categories-container > ul > li")).filter(
        (dropdown) => dropdown !== targetParent
      );

      // Remove the active class from other dropdowns if they have it
      otherDropdowns.forEach((dropdown) => {
        if (dropdown.classList.contains("active")) {
          dropdown.classList.remove("active");
        }
      });
    }

    links.forEach((link) => {
      link.addEventListener("focus", handleFocus);
    });
  };

  /* -------------------------------------------------------------- */
  /* Toggle Mobile Menu */
  /* -------------------------------------------------------------- */
  const mobileMenu = () => {
    const menu = document.querySelector(".mobile-menu");

    menu.addEventListener("click", () => {
      document.documentElement.classList.toggle("mobile-menu-open");
    });
  };

  /* -------------------------------------------------------------- */
  /* Close Mobile Menu On Resize */
  /* -------------------------------------------------------------- */
  const resieCloseNav = () => {
    const html = document.querySelector("html");

    if (window.innerWidth > 840 && hasClass(html, "mobile-menu-open")) {
      html.classList.remove("mobile-menu-open");
    }
  };

  /* -------------------------------------------------------------- */
  /* Search */
  /* -------------------------------------------------------------- */
  const openSearch = () => {
    const search = document.querySelector(".header-search-button");
    const close = document.querySelector(".close-search");

    search.addEventListener("click", () => {
      document.documentElement.classList.toggle("search-open");
    });
    close.addEventListener("click", () => {
      document.documentElement.classList.remove("search-open");
    });
  };

  /* -------------------------------------------------------------- */
  /* Init */
  /* -------------------------------------------------------------- */
  dropdownMenu();
  mobileMenu();
  openSearch();

  window.addEventListener("resize", () => {
    resieCloseNav();
  }, true );
}

export default tbNavigation;